import { render } from "./BackPopup.vue?vue&type=template&id=04988a56&scoped=true"
import script from "./BackPopup.vue?vue&type=script&lang=js"
export * from "./BackPopup.vue?vue&type=script&lang=js"

import "./BackPopup.vue?vue&type=style&index=0&id=04988a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04988a56"]])

export default __exports__